import moment from 'moment';
import { storageDateFormat } from '@/core';
import trip from './trip';
import legTemplate from './legTemplate';

export default function() {
	return {
		...trip(),

		fromAddressId: null,
		toAddressId: null,
		vendorId: null,
		cargoCarrierId: null,

		duration: undefined, // eta - etd days
		departureTime: undefined, // etd time
		arrivalTime: undefined,	// eta time

		legs: [legTemplate()],

		name: '',
		orderTemplateBindings: [],
		generatedTrips: [],
		autoSchedule: false,
		nextTrip: undefined,

		frequency: {
			type: '',
			startDate: moment().startOf('day').format(storageDateFormat),
			endDate: '',
			weekly: {
				monday: false,
				tuesday: false,
				wednesday: false,
				thursday: false,
				friday: false,
				saturday: false,
				sunday: false
			},
			twoWeekly: {
				oddWeeks: {
					monday: false,
					tuesday: false,
					wednesday: false,
					thursday: false,
					friday: false,
					saturday: false,
					sunday: false
				},
				evenWeeks: {
					monday: false,
					tuesday: false,
					wednesday: false,
					thursday: false,
					friday: false,
					saturday: false,
					sunday: false
				}
			},
			monthly: [
				{
					number: 1,
					day: 'monday'
				}
			],
			specificDates: []
		}
	};
}
